import { useMsal } from '@azure/msal-react';
import { Tooltip } from 'component-library';
import { User } from '../../models/ApiModels';
import { GetUser, UpdateUser } from '../../services/UserService';
import { LoadingSpinner } from '../../utils/LoadingSpinner';
import useRequest from '../../utils/net/useRequest';
import { ToggleButton } from '../../utils/ToggleButton';
import useAsyncToggle from '../../utils/useAsyncToggle';

export const SettingsUserSettings = () => {
  const { accounts } = useMsal();
  const account = accounts[0];

  const [currentUser, isLoading] = useRequest<User>(
    () => GetUser(account?.idTokenClaims?.extension_oemUserId as string),
    [account]
  );

  const {
    value: useImperial,
    isUpdating: isUpdatingMeasurementSystem,
    toggle: toggleMeasurementSystem,
  } = useAsyncToggle({
    syncedValue: currentUser?.settings?.measurementSystem === 'Imperial',
    onUpdate: async (nextUseImperial) => {
      if (!currentUser) {
        return;
      }

      await UpdateUser({
        ...currentUser,
        settings: {
          ...currentUser.settings,
          measurementSystem: nextUseImperial ? 'Imperial' : 'Metric',
        },
      });
    },
  });

  return (
    <>
      {isLoading && <LoadingSpinner />}
      {!isLoading && (
        <div className='flex flex-col pt-8'>
          <div className='flex flex-col border-b border-gray-10 pb-5'>
            <span className='prose-heading4 pb-2'>User settings</span>
            <span className='prose-paragraphSmall text-gray-60'>Edit user-specific defaults.</span>

            <div className='flex flex-row justify-between w-full mt-6'>
              <div className='flex flex-row gap-2 items-center justify-start'>
                <span className='prose-paragraphBase text-gray-100'>Use imperial measurement system</span>
                <Tooltip description='Use the imperial measurement system for displaying boat properties. Default is metric.' />
              </div>

              <ToggleButton
                onClick={toggleMeasurementSystem}
                toggled={useImperial}
                buttonClassName={isUpdatingMeasurementSystem ? 'pointer-events-none opacity-30' : ''}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};
